<template>
  <div class="">
    <div class="text-center imgDiv">
      <img class="okImg" src="@/assets/images/Golf/img_ok.png" alt="" />
    </div>
    <div class="mt-5 text-center">
      <span class="title1">접수가 완료되었습니다.</span>
    </div>
    <div class="text-center mt-2">
      <span class="title2">마이페이지에서 접수내용을 확인하실 수 있습니다.</span>
    </div>
    <div class="text-center mt-5">
      <b-button
        class="p-3"
        :to="{name: 'MyPage', params: {reservCategory: '골프클럽', golf_listType: this.listType}}"
        variant="primary"
        >접수내역 확인</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceiptStage4',
  props: {
    listType: String,
    revConfirmList: Array,
  },
};
</script>

<style scoped lang="scss">
.okImg {
  width: 10%;
}

.title1 {
  font-size: 1rem !important;
  font-weight: bolder;
}

.title2 {
  font-size: 0.9rem !important;
}

.imgDiv {
  width: 100%;
  padding-top: 5rem;
}

@media (max-width: 992px) {
  .okImg {
    width: 30%;
  }

  .title1 {
    font-size: 1rem !important;
    font-weight: bolder;
  }

  .title2 {
    font-size: 0.9rem !important;
  }
}
</style>
